import React from "react";
import { useEffect } from "react";
import { gsap } from "gsap/all";
import "./skills.css";

export const Skills = () => {
  useEffect(() => {
    gsap.to(".skills", {
      duration: 2,
      x: "-55%",
      opacity: 1,
      delay: 2,
      scrollTrigger: {
        trigger: ".skills-wrapper",
      },
    });
    gsap.to(".hide-skills", {
      duration: 2,
      x: "50%",
      opacity: 1,
      delay: 2,
      scrollTrigger: {
        trigger: ".skills-wrapper",
      },
    });
  }, []);

  return (
    <div id="skills" className="skills-wrapper">
      <h3>Skills:</h3>
          <div className="hide-skills"></div>
        <section className="skills">
          <div className="openBrak">[</div>

          <div className="languages">
            <span className="skills-title">Languages: </span>
            <span className="skills-list">
            <span className="curlyBrak">&#123;</span>  Ruby, JavaScript, PHP <span className="curlyBrak">&#125;</span>
            </span>
            <br />
            <br />
          </div>

          <div className="web">
            <span className="skills-title">Web Development: </span>
            <span className="skills-list">
            <span className="curlyBrak">&#123;</span>  HTML5, CSS3, Sass <span className="curlyBrak">&#125;</span>
            </span>
            <br />
            <br />
          </div>

          <div className="frameworks">
            <span className="skills-title">Frameworks: </span>
            <span className="skills-list">
            <span className="curlyBrak">&#123;</span>   React.js, Next.js, Express.js, Ruby on Rails, TailwindCSS, Bootstrap <span className="curlyBrak">&#125;</span>
            </span>
            <br />
            <br />
          </div>

          <div className="Databases">
            <span className="skills-title">Databases: </span>
            <span className="skills-list">
            <span className="curlyBrak">&#123;</span>  PostgeSQL, MySQL, MongoDB, HTML, CSS, Sass <span className="curlyBrak">&#125;</span>
            </span>
            <br />
            <br />
          </div>

          <div className="passions">
            <span className="skills-title">Passions: </span>
            <span className="skills-list"> <span className="curlyBrak">&#123;</span>  Tea, Pets, Reading, Travel <span className="curlyBrak">&#125;</span> </span>
            <br />
          </div>
          <div className="closeBrak">]</div>

        </section>
    </div>
  );
};
